import DefaultStyle from "./style/doughnut-legend.css";
/**
 * @typedef LegendStyleOptions
 * @type {object}
 * @property {boolean} styleOverride
 * @property {string} style
 */

class DoughnutLegend extends HTMLElement {
  /**
   * 
   * @param {string} title 
   * @param {color} color 
   * @param {LegendStyleOptions} options 
   */
  constructor(title, color, options) {
    super();
    this.titleElement = document.createElement("span");
    this.titleElement.classList.add("doughnut-legend__title");
    this.setAttribute(":title", title);
    this.titleElement.textContent = title;
    this.colorElement = document.createElement("div");
    this.colorElement.classList.add("doughnut-legend__color");
    this.colorElement.style.backgroundColor = color;
    this.setAttribute(":color", color);
    const styleElement = document.createElement("style");
    styleElement.textContent = this.getStyle(options);
    const shadow = this.attachShadow({
      mode: "open"
    });
    shadow.appendChild(this.colorElement);
    shadow.appendChild(this.titleElement);
    shadow.appendChild(styleElement);
  }

  getStyle(options) {
    if (!options || !options.style) {
      return DefaultStyle;
    }

    if (options.styleOverride) {
      return options.style;
    } // mix


    return DefaultStyle + "\n" + options.style;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == ":title") {
      this.titleElement.textContent = newValue;
      return;
    }

    if (name == ":color") {
      this.colorElement.style.backgroundColor = newValue;
    }
  }

  static get observedAttributes() {
    return [':title', ':color'];
  }

}

customElements.define("doughnut-legend", DoughnutLegend);
export default DoughnutLegend;